'use client';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
const Agb = () => {
  const titleCls = 'text-[16px] font-bb my-[16px]';
  const m_titleCls = 'text-[16px] font-bb my-[16px]';
  return (
    <>
      <WebOnly>
        <div className="agb-page">
          <div className="page-container px-[100px] pb-[50px] max-w-[1880px] mx-auto text-[14px]">
            <h3 className="section-heading hidden">conditions</h3>

            <div className="mce-content mt-3 lg:mt-4 break-words">
              {/* 标题 */}
              <h1 className="title text-center text-[28px] font-bb my-[20px]">
                <span>AGB</span>
              </h1>

              {/* 段落与列表 */}
              <ul className="list-disc pl-6">
                <li className="title">
                  <span>Allgemeine Geschäftsbedingungen (AGB) für de.zeelool.com</span>
                  <br />
                  <span>
                    Vertragsbedingungen im Rahmen von Kaufverträgen, die über das Online-shop
                    de.zeelool.com – im Folgenden „Anbieter&quot; – und dem Kunden – im Folgenden
                    „Kunden&quot; -geschlossen werden.
                  </span>
                </li>
              </ul>

              <h3 className={titleCls}>1.Geltungsbereich, Begriffsbestimmungen</h3>
              <ul className="list-disc pl-6">
                <li>
                  <span className="text-[14px]">
                    Für die Geschäftsbeziehung zwischen den Anbieter und dem Kunden gelten
                    ausschließlich die nachfolgenden Allgemeinen Bedingungen in ihrer zum Zeitpunkt
                    der Bestellung gültigen Fassung. Abweichende Bedingungen des Bestellers werden
                    nicht anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich zu.
                  </span>
                </li>
              </ul>

              <h3 className={titleCls}>2.Bestellvorgang und Vertragsschluss</h3>
              <ul className="list-disc pl-6">
                <li>
                  <span>
                    Sie bestellen in unserem Online-Shop, indem Sie folgende Schritte durchlaufen:
                  </span>
                </li>
                <li>
                  <span>
                    Durch Anklicken der Schaltfläche &quot;in den Warenkorb&quot; oder &quot;mit
                    Sehstärke bestellen&quot; legen Sie den gewünschten Artikel unverbindlich in
                    Ihren Warenkorb.
                  </span>
                </li>
                <li>
                  <span>
                    Durch Streifen (sog. Mouseover) der Schaltfläche &quot;Warenkorb&quot; können
                    Sie Ihre gewählten Produkte einsehen und Artikel löschen.
                  </span>
                </li>
                <li>
                  <span>
                    Den Bestellvorgang betreffend die Produkte im Warenkorb beginnen Sie durch
                    Klicken der Schaltfläche &quot;zur Kasse gehen&quot;.
                  </span>
                </li>
                <li>
                  <span>
                    Innerhalb des Bestellvorgangs geben Sie als Neukunde Ihre Rechnungs- und
                    Lieferadresse an oder loggen sich mit Ihrer E-Mail-Adresse und Kennwort ein,
                    wenn sie bereits über ein Kundenkonto verfügen.
                  </span>
                </li>
                <li>
                  <span>
                    Sie können sodann eine Zahlungsart und im folgenden Schritt eine Versandart
                    auswählen. Ebenso ist eine Änderung der Lieferadresse möglich.
                  </span>
                </li>
                <li>
                  <span>
                    Im letzten Schritt können Sie Ihre Bestellung kontrollieren und einen
                    Gutscheincode eingeben. Wenn alle Angaben korrekt sind, Sie durch Setzen eines
                    Häkchens unsere AGB akzeptieren und Informationen über Ihr gesetzliches
                    Widerrufsrecht zur Kenntnis genommen haben, geben Sie durch Anklicken der
                    Schaltfläche &quot;Kaufen&quot; eine verbindliche Bestellung der in Ihrem
                    Warenkorb enthaltenen Waren ab.
                  </span>
                </li>
                <li>
                  <span>
                    Wir bestätigen Ihnen den Eingang Ihrer Bestellung per E-Mail unmittelbar nach
                    Absenden Ihrer Bestellung (Eingangsbestätigung). Die Eingangsbestätigung stellt
                    noch keine Kaufvertragsannahme dar. Der Kaufvertrag kommt erst zustande, wenn
                    wir Ihre Online-Bestellung durch Versand einer gesonderten Auftragsbestätigung
                    per E-Mail oder durch Auslieferung der Ware an Sie innerhalb von fünf Tagen
                    annehmen.
                  </span>
                </li>
              </ul>

              <h3 className={titleCls}>3.Preise</h3>
              <ul className="list-disc pl-6">
                <li>
                  <span>
                    Alle Preise, die auf der Webseite des Anbieters angegeben sind, verstehen sich
                    zuzüglich Versandkosten. Es gelten die Preise zum Zeitpunkt der Bestellung und
                    können der jeweils aktuell gültigen Preisliste entnommen werden.
                  </span>
                </li>
              </ul>

              <h3 className={titleCls}>4.Versandkosten und Lieferzeiten</h3>
              <ul className="list-disc pl-6">
                <li>
                  <span>
                    Wir lieferen deutschlandweit und in EU-Länder.Die Versandkosten in Deutschland
                    betragen 7.95 € für Standardversand und ab einer Bestellung von 69,00 € ist
                    versandkostenfrei.Versandkosten für die Lieferung nach andere EU-Länder sehen
                    Sie hierunter,
                  </span>
                </li>
              </ul>

              {/* 表格 */}
              <table className="custom-table my-5 border-collapse w-full border-2 border-[#acc9fe] my-[20px]">
                <tbody>
                  <tr className="h-[60px]">
                    <td className="w-[358.727px]" />
                    <td
                      colSpan={2}
                      className="w-[178.562px] text-center border-2 border-[#acc9fe] align-middle"
                    >
                      <span>Standardversand</span>
                    </td>
                    <td
                      colSpan={2}
                      className="w-[135.492px] text-center border-2 border-[#acc9fe] align-middle"
                    >
                      <span>Business Express</span>
                    </td>
                  </tr>
                  <tr className="title-tr bg-[#d3e1fb] h-[60px]">
                    <td className="w-[358.727px] text-center border-2 border-[#acc9fe] align-middle">
                      <span>Länder</span>
                    </td>
                    <td className="w-[112.656px] text-center border-2 border-[#acc9fe] align-middle">
                      <span>Voraussichtliche Lieferung</span>
                    </td>
                    <td className="w-[61.9062px] text-center border-2 border-[#acc9fe] align-middle">
                      <span>Standardversandkosten</span>
                    </td>
                    <td className="w-[70.1094px] text-center border-2 border-[#acc9fe] align-middle">
                      <span>Voraussichtliche Lieferung</span>
                    </td>
                    <td className="w-[61.3828px] text-center border-2 border-[#acc9fe] align-middle">
                      <span>Business-Express-Kosten</span>
                    </td>
                  </tr>
                  <tr className="h-[60px]">
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>Deutschland/Österreich/Schweiz/Belgien/Frankreich/Luxemburg</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>8-14 Tage</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>7.95 €</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>6-11 Tage</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>18.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[60px]">
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>US</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>21-28 Tage</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>7.95 €</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>7-14 Tage</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>18.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[60px]">
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>Andere europäische Regionen</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>nicht verfügbar</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">/</td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>7-14 Tage</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>18.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[60px]">
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>andere Regionen</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>nicht verfügbar</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">/</td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>7-14 Tage</span>
                    </td>
                    <td className="text-center border-2 border-[#acc9fe] align-middle">
                      <span>50.95 €</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <ul className="list-disc pl-6">
                <li>
                  Je nach Produktart und/oder Liefersart gibt es unterschiedliche Lieferzeiten,
                  sofern die Ware vorrätig ist. Befindet sich die Ware im Rückstand, verlängern sich
                  die Lieferzeiten entsprechend. Kunden erhalten eine E-Mail von uns, falls sich die
                  Ware im Rückstand befindet und die Bestellung nicht sofort versendet werden kann.
                </li>
              </ul>

              <h3 className={titleCls}>5.Bezahlung</h3>
              <p className="handle">
                <span>
                  In unserem Shop stehen Ihnen grundsätzlich die folgenden Zahlungsarten zur
                  Verfügung:
                </span>
              </p>

              <h3 className={titleCls}>Kreditkarte</h3>
              <p className="handle">
                <span>
                  Mit Abgabe der Bestellung übermitteln Sie uns gleichzeitig Ihre Kreditkartendaten.
                </span>
              </p>
              <p>
                Nach Ihrer Legitimation als rechtmäßiger Karteninhaber fordern wir unmittelbar nach
                Versendung der Ware Ihr Kreditkartenunternehmen zur Einleitung der
                Zahlungstransaktion auf. Die Zahlungstransaktion wird durch das
                Kreditkartenunternehmen automatisch durchgeführt und Ihre Karte belastet.
              </p>

              <h3 className={titleCls}>PayPal</h3>
              <p className="handle">
                <span>
                  Im Bestellprozess werden Sie auf die Webseite des Online-Anbieters PayPal
                  weitergeleitet. Um den Rechnungsbetrag über PayPal bezahlen zu können, müssen Sie
                  dort registriert sein bzw. sich erst registrieren, mit Ihren Zugangsdaten
                  legitimieren und die Zahlungsanweisung an uns bestätigen. Nach Abgabe der
                  Bestellung im Shop fordern wir PayPal zur Einleitung der Zahlungstransaktion auf.
                </span>
              </p>
              <p>
                <span>
                  Die Zahlungstransaktion wird durch PayPal nach Versendung der Ware automatisch
                  durchgeführt. Weitere Hinweise erhalten Sie beim Bestellvorgang.
                </span>
              </p>

              <h3 className={titleCls}>6.Eigentumsvorbehalt</h3>
              <p className="handle">
                <span>
                  Wir behalten uns das Eigentum an der Ware bis zur vollständigen Zahlung des
                  Kaufpreises vor.
                </span>
              </p>

              <h3 className={titleCls}>7.Transportschäden</h3>
              <p className="handle">
                <span>
                  Werden Waren mit offensichtlichen Transportschäden angeliefert, so reklamieren Sie
                  solche Fehler bitte möglichst sofort beim Zusteller und nehmen Sie bitte
                  unverzüglich Kontakt zu uns auf. Die Versäumung einer Reklamation oder
                  Kontaktaufnahme hat für Ihre gesetzlichen Ansprüche und deren Durchsetzung,
                  insbesondere Ihre Gewährleistungsrechte, keinerlei Konsequenzen. Sie helfen uns
                  aber, unsere eigenen Ansprüche gegenüber dem Frachtführer bzw. der
                  Transportversicherung geltend machen zu können.
                </span>
              </p>

              <h3 className={titleCls}>8.Gewährleistung und Garantien</h3>
              <p className="handle">
                <span>
                  Es gilt das gesetzliche Mängelhaftungsrecht. Informationen zu gegebenenfalls
                  geltenden zusätzlichen Garantien und deren genaue Bedingungen finden Sie jeweils
                  beim Produkt und auf besonderen Informationsseiten im Onlineshop.
                </span>
              </p>

              <h3 className={titleCls}>9.Streitbeilegung</h3>
              <p className="handle">
                <span>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                  bereit, die Sie hier finden https://ec.europa.eu/consumers/odr. Zur Teilnahme an
                  einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir
                  nicht verpflichtet und nicht bereit.
                </span>
              </p>

              <h3 className={titleCls}>GELTENDES RECHT</h3>
              <p className="handle">
                <span>
                  Diese Nutzungsbedingungen und alle separaten Vereinbarungen, mit denen wir Ihnen
                  Dienste zur Verfügung stellen,unterliegen den Gesetzen von UK und werden in
                  Übereinstimmung mit diesen ausgelegt.
                </span>
              </p>
              <p className="handle">Company Name:MICROS INNOVATION TECHNOLOGY LTD</p>
              <p className="handle">
                Company Address:Stockport Road,Manchester,England.(THIS IS NOT ARETURNING ADDRESS)
              </p>

              <div className="4ever-article">
                <h3 className={titleCls}>
                  <span>NAR1&nbsp;&amp;&nbsp;BRN&nbsp;Zertifikation:</span>
                </h3>
              </div>
              <div className="4ever-article">
                <ul className="list-disc pl-6">
                  <li>
                    <span>Hongkong&nbsp;Marvel&nbsp;Limited</span>
                  </li>
                </ul>
              </div>
              <div className="4ever-article">
                <ul className="list-disc pl-6">
                  <li>
                    <span>Geschäftsnummer:&nbsp;74600434</span>
                  </li>
                </ul>
                <div className="4ever-article">
                  <ul className="list-disc pl-6">
                    <li>
                      <span>
                        Addresse: FLAT/RM 02C 30/F DE HUA TOWER 32 HUNG TO ROAD KWUN TONG KL
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="agb-page px-[16px] text-[14px] mb-[80px]">
          <h3 className="section-heading hidden">conditions</h3>
          <div className="mce-content mt-3 lg:mt-4 break-words">
            <h1 className="title text-center my-[18px]">
              <span className="text-[2em]">AGB</span>
            </h1>
            <ul className="list-disc pl-10">
              <li className="title ml-[20px]">
                <span>Allgemeine Geschäftsbedingungen (AGB) für de.zeelool.com</span>
                <br />
                <span>
                  Vertragsbedingungen im Rahmen von Kaufverträgen, die über das Online-shop
                  de.zeelool.com – im Folgenden &quot;Anbieter&quot; – und dem Kunden – im Folgenden
                  &quot;Kunden&quot; -geschlossen werden.
                </span>
              </li>
            </ul>
            <h3 className={m_titleCls}>1.Geltungsbereich, Begriffsbestimmungen</h3>
            <ul className="list-disc pl-10">
              <li className="ml-[20px]">
                <span className="text-[14px]">
                  Für die Geschäftsbeziehung zwischen den Anbieter und dem Kunden gelten
                  ausschließlich die nachfolgenden Allgemeinen Bedingungen in ihrer zum Zeitpunkt
                  der Bestellung gültigen Fassung. Abweichende Bedingungen des Bestellers werden
                  nicht anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich zu.
                </span>
              </li>
            </ul>
            <h3 className={m_titleCls}>2.Bestellvorgang und Vertragsschluss</h3>
            <ul className="list-disc pl-10">
              <li className="ml-[20px]">
                <span>
                  Sie bestellen in unserem Online-Shop, indem Sie folgende Schritte durchlaufen:
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Durch Anklicken der Schaltfläche &quot;in den Warenkorb&quot; oder &quot;mit
                  Sehstärke bestellen&quot; legen Sie den gewünschten Artikel unverbindlich in Ihren
                  Warenkorb.
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Durch Streifen (sog. Mouseover) der Schaltfläche &quot;Warenkorb&quot; können Sie
                  Ihre gewählten Produkte einsehen und Artikel löschen.
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Den Bestellvorgang betreffend die Produkte im Warenkorb beginnen Sie durch Klicken
                  der Schaltfläche &quot;zur Kasse gehen&quot;.
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Innerhalb des Bestellvorgangs geben Sie als Neukunde Ihre Rechnungs- und
                  Lieferadresse an oder loggen sich mit Ihrer E-Mail-Adresse und Kennwort ein, wenn
                  sie bereits über ein Kundenkonto verfügen.
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Sie können sodann eine Zahlungsart und im folgenden Schritt eine Versandart
                  auswählen. Ebenso ist eine Änderung der Lieferadresse möglich.
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Im letzten Schritt können Sie Ihre Bestellung kontrollieren und einen
                  Gutscheincode eingeben. Wenn alle Angaben korrekt sind, Sie durch Setzen eines
                  Häkchens unsere AGB akzeptieren und Informationen über Ihr gesetzliches
                  Widerrufsrecht zur Kenntnis genommen haben, geben Sie durch Anklicken der
                  Schaltfläche &quot;Kaufen&quot; eine verbindliche Bestellung der in Ihrem
                  Warenkorb enthaltenen Waren ab.
                </span>
              </li>
              <li className="ml-[20px]">
                <span>
                  Wir bestätigen Ihnen den Eingang Ihrer Bestellung per E-Mail unmittelbar nach
                  Absenden Ihrer Bestellung (Eingangsbestätigung). Die Eingangsbestätigung stellt
                  noch keine Kaufvertragsannahme dar. Der Kaufvertrag kommt erst zustande, wenn wir
                  Ihre Online-Bestellung durch Versand einer gesonderten Auftragsbestätigung per
                  E-Mail oder durch Auslieferung der Ware an Sie innerhalb von fünf Tagen annehmen.
                </span>
              </li>
            </ul>
            <h3 className={m_titleCls}>3.Preise</h3>
            <ul className="list-disc pl-10">
              <li className="ml-[20px]">
                <span>
                  Alle Preise, die auf der Webseite des Anbieters angegeben sind, verstehen sich
                  zuzüglich Versandkosten. Es gelten die Preise zum Zeitpunkt der Bestellung und
                  können der jeweils aktuell gültigen Preisliste entnommen werden.
                </span>
              </li>
            </ul>
            <h3 className={m_titleCls}>4.Versandkosten und Lieferzeiten</h3>
            <ul className="list-disc pl-10">
              <li className="ml-[20px]">
                <span>
                  Wir lieferen deutschlandweit und in EU-Länder.Die Versandkosten in Deutschland
                  betragen 7.95 € für Standardversand und ab einer Bestellung von 69,00 € ist
                  versandkostenfrei.Versandkosten für die Lieferung nach andere EU-Länder sehen Sie
                  hierunter,
                </span>
              </li>
            </ul>
            <div className="table-wrapper overflow-x-auto -webkit-overflow-scrolling-touch my-[30px]">
              <table className="custom-table w-full table-fixed border-collapse">
                <colgroup>
                  <col className="w-1/2" />
                  <col className="w-1/4" />
                  <col className="w-1/4" />
                </colgroup>
                <tbody>
                  <tr className="h-[80px]">
                    <td
                      colSpan={3}
                      className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]"
                    >
                      <span>Standardversand</span>
                    </td>
                  </tr>
                  <tr className="title-tr bg-[#d3e1fb] h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Länder</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Voraussichtliche Lieferung</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Standardversandkosten</span>
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Deutschland/Österreich/Schweiz/Belgien/Frankreich/Luxemburg</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>10-22 Tage</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>7.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>US</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>10-22 Tage</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>7.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Andere europäische Regionen</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>
                        nicht <br /> verfügbar
                      </span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      /
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>andere Regionen</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>
                        nicht <br /> verfügbar
                      </span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      /
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="table-wrapper overflow-x-auto -webkit-overflow-scrolling-touch my-[30px]">
              <table className="custom-table w-full table-fixed border-collapse">
                <colgroup>
                  <col className="w-1/2" />
                  <col className="w-1/4" />
                  <col className="w-1/4" />
                </colgroup>
                <tbody>
                  <tr className="h-[80px]">
                    <td
                      colSpan={3}
                      className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]"
                    >
                      <span>Business Express</span>
                    </td>
                  </tr>
                  <tr className="title-tr bg-[#d3e1fb] h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Länder</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Voraussichtliche Lieferung</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Business-Express-Kosten</span>
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Deutschland/Österreich/Schweiz/Belgien/Frankreich/Luxemburg</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>6-11 Tage</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>18.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[60px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>US</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>6-11 Tage</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>18.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>Andere europäische Regionen</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>7-14 Tage</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>18.95 €</span>
                    </td>
                  </tr>
                  <tr className="h-[80px]">
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>andere Regionen</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>7-14 Tage</span>
                    </td>
                    <td className="border-2 border-[#acc9fe] text-center whitespace-normal break-words break-all py-[8px] px-[4px]">
                      <span>50.95 €</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ul className="list-disc pl-10">
              <li className="ml-[20px]">
                Je nach Produktart und/oder Liefersart gibt es unterschiedliche Lieferzeiten, sofern
                die Ware vorrätig ist. Befindet sich die Ware im Rückstand, verlängern sich die
                Lieferzeiten entsprechend. Kunden erhalten eine E-Mail von uns, falls sich die Ware
                im Rückstand befindet und die Bestellung nicht sofort versendet werden kann.
              </li>
            </ul>
            <h3 className={m_titleCls}>5.Bezahlung</h3>
            <p className="handle pl-5 relative">
              <span>
                In unserem Shop stehen Ihnen grundsätzlich die folgenden Zahlungsarten zur
                Verfügung:
              </span>
            </p>
            <h3 className={m_titleCls}>Kreditkarte</h3>
            <p className="handle pl-5 relative">
              <span>
                Mit Abgabe der Bestellung übermitteln Sie uns gleichzeitig Ihre Kreditkartendaten.
              </span>
            </p>
            <p>
              Nach Ihrer Legitimation als rechtmäßiger Karteninhaber fordern wir unmittelbar nach
              Versendung der Ware Ihr Kreditkartenunternehmen zur Einleitung der Zahlungstransaktion
              auf. Die Zahlungstransaktion wird durch das Kreditkartenunternehmen automatisch
              durchgeführt und Ihre Karte belastet.
            </p>
            <h3 className={m_titleCls}>PayPal</h3>
            <p className="handle pl-5 relative">
              <span>
                Im Bestellprozess werden Sie auf die Webseite des Online-Anbieters PayPal
                weitergeleitet. Um den Rechnungsbetrag über PayPal bezahlen zu können, müssen Sie
                dort registriert sein bzw. sich erst registrieren, mit Ihren Zugangsdaten
                legitimieren und die Zahlungsanweisung an uns bestätigen. Nach Abgabe der Bestellung
                im Shop fordern wir PayPal zur Einleitung der Zahlungstransaktion auf.
              </span>
            </p>
            <p>
              Die Zahlungstransaktion wird durch PayPal nach Versendung der Ware automatisch
              durchgeführt. Weitere Hinweise erhalten Sie beim Bestellvorgang.
            </p>
            <h3 className={m_titleCls}>6.Eigentumsvorbehalt</h3>
            <p className="handle pl-5 relative">
              <span>
                Wir behalten uns das Eigentum an der Ware bis zur vollständigen Zahlung des
                Kaufpreises vor.
              </span>
            </p>
            <h3 className={m_titleCls}>7.Transportschäden</h3>
            <p className="handle pl-5 relative">
              <span>
                Werden Waren mit offensichtlichen Transportschäden angeliefert, so reklamieren Sie
                solche Fehler bitte möglichst sofort beim Zusteller und nehmen Sie bitte
                unverzüglich Kontakt zu uns auf. Die Versäumung einer Reklamation oder
                Kontaktaufnahme hat für Ihre gesetzlichen Ansprüche und deren Durchsetzung,
                insbesondere Ihre Gewährleistungsrechte, keinerlei Konsequenzen. Sie helfen uns
                aber, unsere eigenen Ansprüche gegenüber dem Frachtführer bzw. der
                Transportversicherung geltend machen zu können.
              </span>
            </p>
            <h3 className={m_titleCls}>8.Gewährleistung und Garantien</h3>
            <p className="handle pl-5 relative">
              <span>
                Es gilt das gesetzliche Mängelhaftungsrecht. Informationen zu gegebenenfalls
                geltenden zusätzlichen Garantien und deren genaue Bedingungen finden Sie jeweils
                beim Produkt und auf besonderen Informationsseiten im Onlineshop.
              </span>
            </p>
            <h3 className={m_titleCls}>9.Streitbeilegung</h3>
            <p className="handle pl-5 relative">
              <span>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
                bereit, die Sie hier finden https://ec.europa.eu/consumers/odr. Zur Teilnahme an
                einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir
                nicht verpflichtet und nicht bereit.
              </span>
            </p>
            <h3 className={m_titleCls}>GELTENDES RECHT</h3>
            <p className="handle pl-5 relative">
              <span>
                Diese Nutzungsbedingungen und alle separaten Vereinbarungen, mit denen wir Ihnen
                Dienste zur Verfügung stellen,unterliegen den Gesetzen von Hong Kong China und
                werden in Übereinstimmung mit diesen ausgelegt.
              </span>
            </p>
            <div>
              <h3 className={m_titleCls}>
                <span>NAR1&nbsp;&amp;&nbsp;BRN&nbsp;Zertifikation:</span>
              </h3>
            </div>
            <div>
              <ul className="list-disc pl-10">
                <li className="ml-[20px]">
                  <span>Hongkong&nbsp;Marvel&nbsp;Limited</span>
                </li>
              </ul>
            </div>
            <div>
              <ul className="list-disc pl-10">
                <li className="ml-[20px]">
                  <span>Geschäftsnummer:&nbsp;74600434</span>
                </li>
              </ul>
              <div>
                <ul className="list-disc pl-10">
                  <li className="ml-[20px]">
                    <span>
                      Addresse: FLAT/RM 02C 30/F DE HUA TOWER 32 HUNG TO ROAD KWUN TONG KL
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </WapOnly>
    </>
  );
};

export default Agb;
